module.exports = __webpack_public_path__ + "img/record-num.d0289dc0.png";